import { render, staticRenderFns } from "./ScoreCardWithNarrative.vue?vue&type=template&id=57257419&scoped=true&"
import script from "./ScoreCardWithNarrative.vue?vue&type=script&lang=js&"
export * from "./ScoreCardWithNarrative.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardWithNarrative.vue?vue&type=style&index=0&id=57257419&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57257419",
  null
  
)

export default component.exports